import { useHistory, useLocation } from "react-router-dom";

export default function useRedirect() {
  const location = useLocation();
  const history = useHistory();

  return (path, { makeReturn = false, useReturn = false } = {}) => {
    if (location.pathname === path) return; // prevent unnecessary redirects and history pollutions

    if (makeReturn && location.pathname !== "/") return history.push(`${path}?return=${encodeURIComponent(location.pathname)}`);

    if (useReturn) {
      const returnQueryParam = new URLSearchParams(location.search).get("return");
      const returnPath = decodeURIComponent(returnQueryParam || path);
      return history.push(returnPath);
    }

    history.push(path);
  };
}
